export interface IHouseCommunicationType {
  code: string
  name: string
}
